import styled ,{css}from 'styled-components';
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
const Wrapper = styled.div`
  width:90%;
  margin:auto;
  display:flex;
  flex-direction:column;
  justify-content:flex-start;

`;
const Header = styled.div`
  height:auto;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:flex-start;
  margin-bottom: 20px;
  @media (max-width:1000px) {
    flex-direction:column-reverse;
  }
`;
const NameWrapper = styled.div`
  height:auto;
  width:70%;
  display:flex;
  flex-direction:column;
  justify-content:flex-start
  align-items:space-between;
  margin-bottom: 10px;
`;

const Row = styled.div`
  width:100%;
  display:flex;
  flex-direction:row;
  justify-content:flex-start;
  gap:5%;
`;
const Column = styled.div`
  width:50%;
  display:flex;
  flex-direction:column;
`;
const Column25 = styled.div`
  width:20%;
  display:flex;
  flex-direction:column;
`;
const ButtonSection = styled.div`
  width:40%;
  display:flex;
  flex-direction:row;
  gap:3px;
  justify-content:flex-end;
  @media (max-width:1000px) {
    width:100%;
    justify-content:flex-start;
  }
`;
const InfoLabel = styled(Label)`
  width:auto;
  display:flex;
  margin:0;
  color: ${(props) => (props.hasdebt=="true" ? 'red' : 'inherit')};
`;
const ScheduleLabel = styled(Label)`
  margin:0;
  display:flex;
  justify-content:flex-start;
  align-items:space-between;
  gap:5px;
  font-weight: bold;
  color: ${(props) => (props.hasdebt=="true" ? 'red' : 'inherit')};
`;

const InputName = styled.input`
  height: 1.5em;
  border: none;
  background-color:transparent;
  font-size: 15px;
  color: #444654;
  font-size:3em;
  align-self:flex-start;
`;
const NavButton = styled(Button)`
  width:50px;
  &:hover {
    background-color:var(--primary-hover-color);
  }
`;
export {Wrapper,Header,NameWrapper,Row,Column, ButtonSection, InfoLabel,ScheduleLabel, InputName, NavButton,Column25 };
